import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const GET_COOPERATION_APPRICANTS = createActionType(
  "GET_COOPERATION_APPRICANTS "
);
export const GET_COOPERATION_APPRICANTS_BY_ID = createActionType(
  "GET_COOPERATION_APPRICANTS_BY_ID"
);
export const REMOVE_COOPERATION_APPRICANTS = createActionType(
  "REMOVE_COOPERATION_APPRICANTS"
);

export const getCooperationsAppricants = () =>
  createAsyncAction(
    GET_COOPERATION_APPRICANTS,
    "/cooperation_appricant/get_all",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getACooperationAppricantsById = (data: any) =>
  createAsyncAction(
    GET_COOPERATION_APPRICANTS_BY_ID,
    `/cooperation_appricant/get_by_id/${data}`,
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeCooperationAppricants = (data: any) =>
  createAsyncAction(
    REMOVE_COOPERATION_APPRICANTS,
    `/cooperation_appricant/remove/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
